import React from 'react';
import { Box, Switch, TextField, MenuItem, Select } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid'; 
import { useData, useDataFunctions } from 'contexts/Data';

import DumbNote from '../DumbNote';

/* Example getOpsStauts result
{
    "changes": [
        {
            "number": "CHG0046626",
            "short_description": "Implementation of Kinesis s3 upload for meteo data",
            "description": "[PTSKCL-1929] Implementation of Kinesis in meteo - Jira \r\nThe DBA team wants the s3 uploaded data to",
            "state": "Authorize",
            "scheduled_start": "2025-04-09 12:20:55",
            "scheduled_end": "2025-04-09 12:21:12",
            "link": "https://prologis.service-now.com/nav_to.do?uri=change_request.do?sys_id=0323d9851bb0ea90b4a94378b04bcbad",
            "implementation_plan": "Code changes implented through automated CI/CD pipeline. No Communication is needed.",
            "test_plan": "Implemented in lower environment and verified.",
            "risk_impact_analysis": "This change won't impact the actual application.",
            "close_notes": "",
            "close_code": "",
            "assigned_to": "smathew3@prologis.com"
        },
        {
            "number": "CHG0046600",
            "short_description": "Yardi Hotfix - Standard Change - hotfix/INC0461391 - ModifyHUCreditNoteRef PR# 2751",
            "description": "Datafix to resolve issues. No schema changes.\r\n \r\nPull Request Description\r\nDescription: Alter :CI c",
            "state": "Closed",
            "scheduled_start": "2025-04-03 13:45:00",
            "scheduled_end": "2025-04-03 14:15:00",
            "link": "https://prologis.service-now.com/nav_to.do?uri=change_request.do?sys_id=0c09347b1ba4ee50b4a94378b04bcb81",
            "implementation_plan": "Implementation Plan:\r\n1.  UST/PWC to deploy hotfix to Production via Jenkins.\r\n2.  Yardi team to communicate to user and Data and Analytics team.\r\n3.  User to verify change.\r\n4.  Close RFC",
            "test_plan": "Test Plan - Prior to Change\r\n1.  Sandbox data refreshed from Production weekly.\r\n2.  Hotfix deployed to Sandbox\r\n3.  User to verify hotfix and give approval to move to PD\r\n\r\nTest Plan - After Change\r\n1. Communicate change was completed to user\r\n2. User to verify in PD.",
            "risk_impact_analysis": "Low risk.  Can easily be backed out by restoring from DataHistory table.\r\n\r\nNo downstream impact",
            "close_notes": "Deployed successfully using ADO.",
            "close_code": "successful",
            "assigned_to": "cvrettos@prologis.com"
        },...
    ],
    "problems": [
        {
            "number": "PRB0040673",
            "short_description": "EU CRC Users not getting redirected to FM from the notification links (EC-8222) - Fixed 4/3/25",
            "description": "When the EU CRC user clicks the link for a ticket in an FM notification email, he is not getting red",
            "state": "Root Cause Analysis",
            "opened_at": "2025-03-19 16:11:55",
            "link": "https://prologis.service-now.com/nav_to.do?uri=problem.do?sys_id=05531c8747986e140080c789826d4347",
            "assigned_to": "rmudunuru@prologis.com"
        },
        {
            "number": "PRB0040221",
            "short_description": "Tableau is not accessible for most of the users",
            "description": "",
            "state": "New",
            "opened_at": "2022-07-22 08:35:00",
            "link": "https://prologis.service-now.com/nav_to.do?uri=problem.do?sys_id=090b4a521b74591065fba974604bcbfc",
            "assigned_to": null
        },...
    ],
    "notes": "# No active issues",
    "conversation_id": "2cb30738-4d9d-45dc-a7ef-7933bb0dbcec"
}

*/

export default function OperationsManager() {
  const data = useData(); 
  const dataFunctions = useDataFunctions(); 

  const [changes, setChanges] = React.useState([]);
  const [problems, setProblems] = React.useState([]);
  const [notes, setNotes] = React.useState("");

  React.useEffect(() => {
    dataFunctions.getOpsStatus()
      .then((result) => {
        console.log(result);
        setChanges(result.changes || []);
        setProblems(result.problems || []);
        setNotes(result.notes || "");
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);


  return (
    <Box sx={{ height: 600, width: '100%' }}>
      <h1>Operations Manager</h1>
      <h2>Notes</h2>
      <DumbNote noteType="operations_status_note" />
      <h2>Changes</h2>
      <DataGrid
        rows={changes}
        columns={[
          { field: 'number', headerName: 'Number', width: 150 },
          { field: 'short_description', headerName: 'Short Description', width: 300 },
          { field: 'description', headerName: 'Description', width: 300 },
          { field: 'state', headerName: 'State', width: 150 },
          { field: 'scheduled_start', headerName: 'Scheduled Start', width: 200 },
          { field: 'scheduled_end', headerName: 'Scheduled End', width: 200 },
          { field: 'assigned_to', headerName: 'Assigned To', width: 200 },
        ]}
        getRowId={(row) => row.number}
        components={{ Toolbar: GridToolbar }}
        />
      <h2>Problems</h2>
      <DataGrid
        rows={problems}
        columns={[
          { field: 'number', headerName: 'Number', width: 150 },
          { field: 'short_description', headerName: 'Short Description', width: 300 },
          { field: 'description', headerName: 'Description', width: 300 },
          { field: 'state', headerName: 'State', width: 150 },
          { field: 'opened_at', headerName: 'Opened At', width: 200 },
          { field: 'assigned_to', headerName: 'Assigned To', width: 200 },
        ]}
        getRowId={(row) => row.number}
        components={{ Toolbar: GridToolbar }}
        />
      </Box>

  );
}
